import React from "react";
import { createDispatchAlertCaptureController } from "../lib/dispatchAlertCaptureRuntime.js";

const INITIAL_CAPTURE_STATE = {
  campaignId: "",
  errorMessage: "",
  isActive: false,
  revision: 0,
  status: "idle",
};

export default function useDispatchAlertCapture({
  pathname = "",
  search = "",
} = {}) {
  const [captureState, setCaptureState] = React.useState(INITIAL_CAPTURE_STATE);
  const controllerRef = React.useRef(null);

  React.useEffect(() => {
    let isMounted = true;
    const controller = createDispatchAlertCaptureController({
      onStateChange(nextState) {
        if (isMounted) {
          setCaptureState(nextState);
        }
      },
      route: { pathname, search },
    });
    controllerRef.current = controller;
    void controller.start();

    return () => {
      isMounted = false;
      controller.dispose();
      controllerRef.current = null;
    };
  }, []);

  React.useLayoutEffect(() => {
    void controllerRef.current?.refreshRoute({ pathname, search });
  }, [pathname, search]);

  return captureState;
}
